import { useMutation } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";

export interface IInitiateSubscriptionPayload {
  plan_id: number;
  success_url?: string;
  cancel_url?: string;
}

export type IInitiateSubscriptionResponse =
  | { provider: "stripe"; checkout_url: string }
  | { provider: "razorpay"; provider_payload: { key_id: string; subscription_id: string } };

export const useInitiateSubscription = () => {
  return useMutation<IInitiateSubscriptionResponse, Error, IInitiateSubscriptionPayload>({
    mutationFn: async (payload: IInitiateSubscriptionPayload) => {
      return await httpService.post<IInitiateSubscriptionResponse>(
        API_CONFIG.path.stripeCheckout,
        payload as unknown as Record<string, unknown>
      );
    },
  });
};
